import { Alert, Collapse, Dropdown } from './_bootstrap';

(function () {

  let dropdowns = document.querySelectorAll('.dropdown-toggle')
  for (let i = 0; i < dropdowns.length; i++) {
    let dropdownToggle = dropdowns[i];
    dropdownToggle = new Dropdown(dropdownToggle)
    dropdownToggle._inNavbar = false;
  }
	// * Tooltip initialization, remove it if not necessary
	// document
	// 	.querySelectorAll('[data-toggle="tooltip"]')
	// 	.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	// document
	//	.querySelectorAll('.toast')
	//	.forEach((toastElement) => new Toast(toastElement));

	// * Popover initialization, remove it if not necessary
	// const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
	// [...popoverTriggerList].map(popoverTriggerEl => new Popover(popoverTriggerEl));

})();
